import styled, { css } from 'styled-components';

export const Label = styled.label`
    display: block;
    font-size: 0.875rem;
    font-weight: 600;
    margin-bottom: 8px;
    margin-left: 10px;
    line-height: 17px;
    ${({ hasError }) =>
        hasError &&
        css`
            color: #ea2e4c;
        `}
`;

export const StyledInput = styled.input`
    background: transparent;
    outline: none;
    height: 33px;
    width: 100%;
    border: 1px solid #cccccc;
    border-radius: 2px;
    background-color: #ffffff;
    padding: 0 10px;
    margin-bottom: 24px;

    ${({ hasError }) =>
        hasError &&
        css`
            border: 1px solid #ea2e4c;
        `}

    ::placeholder {
        color: rgba(0, 0, 0, 0.38);
    }
`;
